import React from 'react';

interface ISwitchButtonProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export function SwitchButton(props: ISwitchButtonProps) {
  return <input className='switchButton' type='checkbox' {...props} />;
}
